import { Controller } from "@hotwired/stimulus"

// Mobile-only drawer for the marketplace filters + map sidebar.
// On narrow viewports the sidebar is reordered below the product listings, so a
// plain scroll-anchor gave no visible feedback. This turns the "Filters / Map"
// button into a real toggle that slides the panel in as an overlay drawer.
// Targets: button, backdrop
export default class extends Controller {
  static targets = ["button", "backdrop"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    // Signal that JS is live: only then do we hide the panel off-canvas. Without
    // this the sidebar stays in normal document flow, matching the old fallback.
    this.element.classList.add("-drawer-ready")
  }

  disconnect() {
    this.close()
    this.element.classList.remove("-drawer-ready")
  }

  toggle() {
    if (this.element.classList.contains("-drawer-open")) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.element.classList.add("-drawer-open")
    document.body.classList.add("-drawer-lock")
    document.addEventListener("keydown", this.handleKeydown)

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "true")
      this.buttonTarget.textContent = "Close filters / map"
    }

    // Leaflet renders blank tiles when it initialises in a hidden container, so
    // tell the map to recalculate its size now that the drawer is visible.
    this.dispatch("opened", { target: window })
  }

  close() {
    if (!this.element.classList.contains("-drawer-open")) return

    this.element.classList.remove("-drawer-open")
    document.body.classList.remove("-drawer-lock")
    document.removeEventListener("keydown", this.handleKeydown)

    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", "false")
      this.buttonTarget.textContent = "Filters / Map"
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
